// custom typefaces
require('typeface-noto-sans-kr')
require('typeface-catamaran')

// polyfill
require('intersection-observer')

require("prismjs/themes/prism-solarizedlight.css")

const metaConfig = require('./gatsby-meta-config')
